import { ProviderRecord } from "models/view-models/providers/provider-record";
import { ProviderGoalRecord } from "models/view-models/providers/provider-goal-record";
import { ServiceHookFactory } from "utilities/services/service-hook-factory";
import { ProviderSummaryRecord } from "models/view-models/providers/provider-summary-record";

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint: string = "providers";
const resourceType: typeof ProviderRecord = ProviderRecord;
const resourceEndpoint = `${baseEndpoint}/:id`;
const patchIsActiveEndpoint = `${resourceEndpoint}/is-active`;
const providerYearGoalsEndpoint = `${resourceEndpoint}/provider-year-goals`;
const providerSummaryEndpoint = `${resourceEndpoint}/summary`;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region enum
// -------------------------------------------------------------------------------------------------

// #endregion enum

export interface ProviderResourcePathParams {
    id: number;
}
export interface ListProvidersQueryParams {
    isActive?: boolean;
    searchText?: string;
    name?: string;
    netsuiteId?: string;
    skip?: number;
    take?: number;
}

export interface PatchProviderIsActiveParams {
    isActive: boolean;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const ProviderService = {
    useCreate: ServiceHookFactory.useCreate<ProviderRecord>(resourceType, baseEndpoint),

    /**
     * Custom hook for leveraging service get calls in React components
     */
    useGet: ServiceHookFactory.useGet<ProviderRecord, ProviderResourcePathParams>(
        resourceType,
        resourceEndpoint
    ),

    useGetProviderGoal: ServiceHookFactory.useNestedList<
        ProviderGoalRecord,
        ProviderResourcePathParams,
        undefined
    >(ProviderGoalRecord, providerYearGoalsEndpoint),

    useGetProviderSummary: ServiceHookFactory.useNestedList<
        ProviderSummaryRecord,
        ProviderResourcePathParams,
        undefined
    >(ProviderSummaryRecord, providerSummaryEndpoint),

    /**
     * Custom hook for leveraging service update calls in React components
     */
    useUpdate: ServiceHookFactory.useUpdate<ProviderRecord, ProviderResourcePathParams>(
        resourceType,
        resourceEndpoint
    ),

    /**
     * Custom hook for leveraging service index calls in React components
     */
    useList: ServiceHookFactory.useList<ProviderRecord, ListProvidersQueryParams>(
        resourceType,
        baseEndpoint
    ),

    /**
     * Custom hook for leveraging service patch calls in React components
     */
    usePatchIsActive: ServiceHookFactory.usePatch<
        ProviderRecord,
        ProviderResourcePathParams,
        PatchProviderIsActiveParams
    >(resourceType, patchIsActiveEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ProviderService };

// #endregion Exports
